import React from "react";
import ReactDOM from "react-dom"
import '../styles/Modal.css'

function PedidoPModal (props) {
    if(!props.isOpen){
        return null
    }
    
    return ReactDOM.createPortal(
        <div className="abed__Modal" tabIndex='-1'>
            <div className="abed__Modal--container w-100 w-sm-75 w-md-50 w-lg-50 w-xl-50 m-auto">
                <div className="modal-header">
                    <h5 className="modal-header-title">{props.title}</h5>
                    <button className="close" onClick={props.onClose}>X</button>
                </div>
                <div className="modal-body bg-color">
                    {props.children}
                </div>
                <div className="modal-footer bg-color-footer">
                    {/* Footer content if needed */}
                </div>
            </div>
        </div>,
        document.getElementById('modal')
    );
} 

export default PedidoPModal;